Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, 
		"d+": this.getDate(), 
		"H+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		"S": this.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((
			"00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}

export const checkPhone = function(phone) {
	if (!(/^1[3456789]\d{9}$/.test(phone))) {
		return false;
	}
	return true;
}
export const getQueryString = function(name) {
	const url_string = window.location.href;
	const url = new URL(url_string);
	return url.searchParams.get(name);
}


export const isInWeixin = () => {
	if (navigator && navigator.userAgent) {
		var ua = navigator.userAgent.toLowerCase();
		var isWeixin = ua.indexOf('micromessenger') != -1;
		if (isWeixin) {
			return true;
		} else {
			return false;
		}
	} else {
		return false
	}
}

export const generateRandomString = (length) => {
	var result = '';
	var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var charactersLength = characters.length;

	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

export const generateUUID = () => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0,
			v = c === 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export const recursiveJsonParse = (jsonString) => {
	const parsedData = JSON.parse(jsonString, (key, value) => {
		if (typeof value === 'string') {
			try {
				return JSON.parse(value);
			} catch (error) {
				return value;
			}
		}
		return value;
	});
	return parsedData;
}


const isSnakeCase = new RegExp('_(\\w)', 'g');
const isCamelCase = new RegExp('[A-Z]', 'g');

function parseObjectKeys(obj, type) {
	let parserReg;
	let parser;
	switch (type) {
		case 'snake2camel':
			parser = common.snake2camel
			parserReg = isSnakeCase
			break
		case 'camel2snake':
			parser = common.camel2snake
			parserReg = isCamelCase
			break
	}
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			if (parserReg.test(key)) {
				const keyCopy = parser(key)
				obj[keyCopy] = obj[key]
				delete obj[key]
				if (Object.prototype.toString.call((obj[keyCopy])) === '[object Object]') {
					obj[keyCopy] = parseObjectKeys(obj[keyCopy], type)
				} else if (Array.isArray(obj[keyCopy])) {
					obj[keyCopy] = obj[keyCopy].map((item) => {
						return parseObjectKeys(item, type)
					})
				}
			}
		}
	}
	return obj
}

export const snake2camel = function(value) {
	return value.replace(isSnakeCase, (_, c) => (c ? c.toUpperCase() : ''))
}

export const camel2snake = function(value) {
	return value.replace(isCamelCase, str => '_' + str.toLowerCase())
}

export const snake2camelJson = function(obj) {
	return parseObjectKeys(obj, 'snake2camel');
};

export const camel2snakeJson = function(obj) {
	return parseObjectKeys(obj, 'camel2snake');
};


export const getPriceArr = (price) => {
	const priceStr = String(price)
	if (priceStr.indexOf('.') !== -1) {
		return priceStr.split('.')
	} else {
		return [priceStr, '00']
	}
}


function convertExpNumber(num) {
	let str = num.toString();
	if (!/[eE]/.test(str)) return str;

	const [mantissa, exponent] = str.split(/[eE]/);
	let [intPart, decPart] = mantissa.split('.');
	decPart = decPart || '';
	const exp = parseInt(exponent, 10);

	if (exp > 0) {
		const zeros = exp - decPart.length;
		return zeros >= 0 ?
			intPart + decPart + '0'.repeat(zeros) :
			intPart + decPart.slice(0, exp) + '.' + decPart.slice(exp);
	} else {
		const zeros = Math.abs(exp) - intPart.length;
		return zeros >= 0 ?
			'0.' + '0'.repeat(zeros) + intPart + decPart :
			intPart.slice(0, exp) + '.' + intPart.slice(exp) + decPart;
	}
}

export const formatNumber = function(num) {
	const str = convertExpNumber(num);
	const parts = str.split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return parts.join('.');
}

export const getRandomInt = function(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
}